var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"view-ui-button-skip button-secondary",on:{"click":function($event){return _vm.$emit('skip')}}},[_vm._v("Skip")])
}
var staticRenderFns = []

export { render, staticRenderFns }